import React from 'react';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import OneDanmaku from './OneDanmaku';
import { arrDiff } from '../../utils/util';
const FONT_SIZE = 12;
const MAX_ROW = 3;
const INIT_TIME = 4000;
let TIME = INIT_TIME;

@inject('rootStore')
@observer
class Danmaku extends React.Component {
  @observable showingComments = [[], [], []]; //当前正在展示的评论  3行
  @observable shownComments = []; //已经显示完成的评论
  @observable danmakuCommentList = []; //因为大图页要同时显示弹幕和评论列表，所以不能直接去操作commentStore.commentList了
  @action removeComment = (row, id) => {
    console.log('remove', row, id);
    const index = this.showingComments[row].findIndex(
      comment => +comment.id === +id
    );
    this.showingComments[row].splice(index, 1);
  };

  @action insert = (index, delay = 0) => {
    const comment0 = this.danmakuCommentList.shift();
    if (comment0) {
      this.shownComments = [...this.shownComments, comment0];
      this.showingComments[index].push({
        ...comment0,
        delay
      });
    } else {
      console.log('评论已经加载完了');
    }
  };

  check = () => {
    const rand = Math.floor(Math.random() * MAX_ROW); //随机一行
    const currentRow = this.showingComments[rand];
    //console.log('check',currentRow);
    //是空行，并且评论数据没有完，插入
    if (this.danmakuCommentList.length) {
      if (!currentRow.length) {
        console.log('I am in', rand);
        this.insert(rand);
      } else {
        //如果当前行不是空行，但是已经有足够的时间间隔，也可以插进去--暂不处理
        //先最多只能2条并行显示，否则不好处理
        if (currentRow.length === 1) {
          const pre = currentRow[0];
          const preWidth = this.getContent(pre).length * FONT_SIZE;
          const velocity = document.body.clientWidth / TIME;
          const minDelay = Math.ceil(preWidth / velocity);
          this.insert(rand, minDelay);
        }
      }
    }
  };
  componentWillUnmount() {
    clearInterval(this.timer);
    clearInterval(this.getListTimer);
    TIME = INIT_TIME; // 每次重置之后需要将这个值回复，否则弹幕越来越慢
    //清空评论的东西（避免弹幕内容错乱）
    // 已经看不懂为什么要清空评论了，现在如果清空了评论，会导致commentStore的commentList被清空，在Detail页面没有重新获取的情况下
    // 用户点击评论会看到空的评论，所以这里不能清空
    // this.props.rootStore.commentStore.clear();
  }
  setTime() {
    const { clientWidth } = document.body;
    const ratio = clientWidth / 360;
    TIME = Math.ceil((ratio || 1) * TIME);
  }
  //考虑到CommentWrapper和Danmaku都需要评论，但是分别获取会导致各种因为合并之类的warning问题，所以只在CommentWrapper上获取评论
  //这里不做获取操作
  getDanmakuList = () => {
    //this.danmakuCommentList = [...this.props.rootStore.commentStore.commentList];
    this.danmakuCommentList = arrDiff(
      this.props.rootStore.commentStore.commentList,
      this.shownComments
    ).filter(one => {
      const { content } = one || {};
      // 过滤掉红包
      return !/^\$\$REDPACKAGE/.test(content);
    });
  };
  componentDidMount() {
    this.timer = setInterval(this.check, 1000);
    //加载该组件后先获取一次
    this.getDanmakuList();
    this.getListTimer = setInterval(this.getDanmakuList, 10000);
    this.setTime();
  }
  //最新的原型上已经不显示昵称了
  getContent(comment) {
    const { content /*,nickname*/ } = comment;
    try {
      return decodeURIComponent(content);
    } catch (e) {
      console.error(`content cannot be decoded:`, content);
      return '';
    }
  }
  render() {
    //console.log(this.showingComments[0].length);
    //console.log(TIME,'time');
    return this.showingComments.map((commentRow, rowIndex) => {
      return commentRow.map(comment => (
        <OneDanmaku
          key={comment.id}
          endCb={this.removeComment.bind(this, rowIndex, comment.id)}
          text={this.getContent(comment)}
          image={comment.photo || require('../../assets/logo-128.jpg')}
          top={30 + rowIndex * 20}
          time={TIME}
          delay={comment.delay || 0}
        />
      ));
    });
  }
}

export default Danmaku;
